// LegalDocument.js
// Shared layout + typography for legal pages (Privacy Policy, Terms of Service).
// Keeps both pages visually identical — styles live here only.

import React from "react";

const APP_THEME = "#d4f53c";
export const SUPPORT_EMAIL = "support@rosterableapp.com";

// ─── Content primitives ───────────────────────────────────────────────────────

export const H2 = ({ children }) => <h2 style={styles.h2}>{children}</h2>;
export const H3 = ({ children }) => <h3 style={styles.h3}>{children}</h3>;
export const P  = ({ children }) => <p style={styles.p}>{children}</p>;
export const Strong = ({ children }) => <strong style={styles.strong}>{children}</strong>;

export const Bullets = ({ items }) => (
  <ul style={styles.ul}>
    {items.map((item, i) => (
      <li key={i} style={styles.li}>{item}</li>
    ))}
  </ul>
);

// Tappable support email (mailto:)
export const Mail = () => (
  <a href={`mailto:${SUPPORT_EMAIL}`} style={styles.link}>{SUPPORT_EMAIL}</a>
);

// Tappable external link (opens in a new tab)
export const Link = ({ href, children }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" style={styles.link}>
    {children}
  </a>
);

// ─── Page wrapper ─────────────────────────────────────────────────────────────
// Renders the container, title, and effective date; sections go in as children.

export default function LegalDocument({ title, effectiveDate, children }) {
  return (
    <div style={styles.container}>
      <h1 style={styles.title}>{title}</h1>
      {effectiveDate && (
        <p style={styles.effective}>Effective Date: {effectiveDate}</p>
      )}
      {children}
    </div>
  );
}

// ─── Styles ───────────────────────────────────────────────────────────────────

const styles = {
  container: {
    maxWidth: "480px",
    margin: "0 auto",
    padding: "32px 20px 80px",
  },
  title: {
    fontSize: "26px",
    fontWeight: "900",
    fontStyle: "italic",
    color: "#fff",
    letterSpacing: "0.5px",
    marginBottom: "6px",
  },
  effective: {
    fontSize: "13px",
    fontWeight: "600",
    color: APP_THEME,
    marginBottom: "20px",
  },
  h2: {
    fontSize: "17px",
    fontWeight: "800",
    color: "#fff",
    margin: "26px 0 8px",
  },
  h3: {
    fontSize: "14px",
    fontWeight: "700",
    color: "rgba(255,255,255,0.85)",
    margin: "16px 0 6px",
  },
  p: {
    fontSize: "14px",
    color: "rgba(255,255,255,0.6)",
    lineHeight: 1.7,
    margin: "0 0 10px",
  },
  ul: {
    margin: "0 0 10px",
    paddingLeft: "20px",
    listStyle: "disc",
  },
  li: {
    fontSize: "14px",
    color: "rgba(255,255,255,0.6)",
    lineHeight: 1.7,
    marginBottom: "5px",
  },
  strong: {
    color: "rgba(255,255,255,0.85)",
    fontWeight: "700",
  },
  link: {
    color: APP_THEME,
    textDecoration: "none",
    fontWeight: "600",
  },
};
